<div class="reschedule-public-profile-container">
    
    <div class="mock-card">
        <div class="re-schedule-header" *ngIf="publicProfile">
            <div class="title">{{ 'publicProfiles.rescheduleProfile.text1' | translate:locale.language }}</div>
            <div class="header-content">
                <div class="avatar" *ngIf="publicProfile.ubicacionFoto" [ngStyle]="{backgroundImage:'url(' + publicProfile.ubicacionFoto + ')'}"></div>
                <span class="avatar" *ngIf="!publicProfile.ubicacionFoto" [ngStyle]="{'background-color': initials.color}">
                    {{initials.initials}}
                </span>
                <span class="info">
                    <span>{{publicProfile.nombrePersona}}</span>
                    <span>{{specialties}}</span>
                </span>
            </div>
        </div>

        <app-appointment-locations></app-appointment-locations>

    </div>    

</div>